export const unwrapNormalizedPayload = <T = any>(payload: any): T => {
  if (!payload || typeof payload !== 'object') {
    return payload as T;
  }

  if (payload.success === true && Object.prototype.hasOwnProperty.call(payload, 'data')) {
    return payload.data as T;
  }

  return payload as T;
};
